import React, { ComponentType, HTMLAttributes } from 'react';
import { styled } from '@mui/material/styles';

const FilterTabsBar: ComponentType<HTMLAttributes<HTMLDivElement>> = styled('div')({
  flexGrow: 1,
  display: 'flex',
  //gap: '10px',
  padding: '2px 0',
});

export default FilterTabsBar;